import React from 'react'
import _ from 'lodash'
import { Card, Col, Row } from 'antd'
import { PresetItem } from '../../styles/shared.style'
import PropTypes from 'prop-types'

const PresetList = (props) => {
  const { presets, renderItemActive, onClickItem, select } = props
  return (
    <Card style={{ marginTop: 10, height: 450, overflowY: 'scroll' }} destroyOnClose={true}>
      {!_.isEmpty(presets) &&
        presets.map((item, index) => {
          return (
            <Row key={index}>
              <Row style={{ width: '100%' }}>
                <span style={{ color: 'green', fontSize: 18 }}>
                  {item.categoryName}
                </span>
              </Row>
              <Row type="flex" gutter={8}>
                {item.presetList.map((presets, idx) => {
                  return (
                    <Col key={idx}>
                      {select ? (<PresetItem
                        active={renderItemActive(presets)}
                        onClick={() => onClickItem(presets)}>
                        <img
                          src={presets.cover.url}
                          alt=""
                          width={64}
                          height={64}
                        />
                      </PresetItem>) :
                        (<PresetItem
                          active={false}
                          onClick={() => onClickItem(presets)}>
                          <img
                            src={presets.cover.url}
                            alt=""
                            width={64}
                            height={64}
                          />
                        </PresetItem>)}
                    </Col>
                  )
                })}
              </Row>
            </Row>
          )
        })}
    </Card>
  )
}

PresetList.propTypes = {
  presets: PropTypes.array.isRequired,
  renderItemActive: PropTypes.func.isRequired,
  onClickItem: PropTypes.func.isRequired
}

export default PresetList
